import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subject, BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserSubmittableService } from './user-submittable-service';

import { InjectionPressureDataBatch } from '../_models/injection-pressure-data-batch';
import { InjectionPressureDataRecord } from '../_models/injection-pressure-data-record';
import { UserSubmittableDataBatch } from '../_models/user-submittable-data-batch';

@Injectable({
  providedIn: 'root'
})
export class BHPService extends UserSubmittableService {

  public currentRecords: EventEmitter<Array<InjectionPressureDataRecord>> = new EventEmitter<Array<InjectionPressureDataRecord>>(null);
  public getInjectionPressureDataWorking: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public currentInjectionPressureBatch: BehaviorSubject<InjectionPressureDataBatch> = new BehaviorSubject<InjectionPressureDataBatch>(null);
  public currentInjectionPressureRecords: EventEmitter<Array<InjectionPressureDataRecord>> = new EventEmitter<Array<InjectionPressureDataRecord>>(null);


  //This one is the first page - injection volumes
  public bhpDataColumns;
  constructor(public httpClient: HttpClient)
  {
    super(httpClient);

    this._controllerName = "injectionpressure"
  }

  public GetInjectionPressureData(wellId: number) {

    if (!this.getInjectionPressureDataWorking.value) {

      var tempInjRecs = new Array<InjectionPressureDataRecord>();

      this.currentRecords.next(tempInjRecs);

      this.getInjectionPressureDataWorking.next(true);

      this.httpClient.get("api/injectionpressure/well/" + wellId).subscribe((result: Array<InjectionPressureDataRecord>) => {

        this.getInjectionPressureDataWorking.next(false);
        this.currentRecords.emit(result);
      });
    }
  }

  public GetLastInjectionRecordWithWellId(wellId: number): Promise<InjectionPressureDataRecord> {

    var ret;

    if (wellId == null) {
      ret = new Promise<InjectionPressureDataRecord>((resolve, reject) => {
        resolve(null);
      });
    }
    else {
      ret = <Promise<InjectionPressureDataRecord>>this.httpClient.get("api/injectionpressure/LastInjectionWithWellId/" + wellId).toPromise();
    }

    return ret;
  }

  public getDataColumnsListPromise() {
    //If data columns dont exist make call to backend service
    if (!this.bhpDataColumns) {
      return this.httpClient.get("api/injectionpressure/Columns").toPromise().then((result: any) => {
        this.bhpDataColumns = result.bhpDataColumns;
        return [this.bhpDataColumns];
      });
    } else {
      return Promise.resolve([this.bhpDataColumns]);
    }
  }

  public async getCombinedDataColumnsList(methodId = null) {
    let labelList = [];
    let dataColumnObjs = await this.getDataColumnsListPromise();

    //If methodId is proveded, set the necessary required fields.
    if (methodId) {
      dataColumnObjs = [this.updateDataColumnsByMeasurementMethod(this.bhpDataColumns, methodId)];
    } else {
      dataColumnObjs = [this.bhpDataColumns];
    }

    //interate over all dataColumns add all labels to an array
    dataColumnObjs.forEach(dataColumnObj => {
      Object.keys(dataColumnObj).forEach(key => {

        var labelProps = {
          key,
          label: dataColumnObj[key].label,
          required: dataColumnObj[key].required,
          persist: dataColumnObj[key].persist,
          type: "number",
          options: null
        };

        //Don't assign undefined to this
        if (dataColumnObj[key].type != null) {
          labelProps.type = dataColumnObj[key].type;

          //Also check if the type happens to be of the many to many type, and if so, set the options property.
          labelProps.options = dataColumnObj[key].options;
        }

        labelList.push(labelProps);
      });
    });

    return labelList;
  }

  public async GetPersistList() {
    let combinedDataColumnsList = await this.getCombinedDataColumnsList();
    return combinedDataColumnsList.filter(dataColumnObj => {
      return dataColumnObj.persist;
    }).map(dataColumnObj => {
      return dataColumnObj.key
    });
  }

  public updateDataColumnsByMeasurementMethod(dataCol, methodId) {
    // unrequire and enable all cols
    dataCol.ShutinBHPQuarterlyCalc.required = false;
    dataCol.ShutinBHPQuarterlyMeas.required = false;
    dataCol.ShutinBHPDaily.required = false;

    dataCol.ShutinBHPQuarterlyCalc.disabled = false;
    dataCol.ShutinBHPQuarterlyMeas.disabled = false;
    dataCol.ShutinBHPDaily.disabled = false;

    if (methodId == 1) {
      dataCol.ShutinBHPQuarterlyCalc.required = true;

      dataCol.ShutinBHPQuarterlyMeas.disabled = true;
      dataCol.ShutinBHPDaily.disabled = true;

      dataCol.MeaDayInjLiqDens.disabled = true;
      dataCol.MaxDayEstBhp.disabled = false;
      dataCol.AveDayEstBhp.disabled = false;
      dataCol.AveDayMeasBhp.disabled = true;
      dataCol.MaxDayMeasBhp.disabled = true;
      
      dataCol.ShutinTimeForStaticPress.required = true;
      dataCol.ShutinTimeForStaticPress.disabled = false;
    }
    else if (methodId == 2) {
      dataCol.ShutinBHPQuarterlyMeas.required = true;

      dataCol.ShutinBHPQuarterlyCalc.disabled = true;
      dataCol.ShutinBHPDaily.disabled = true;

      dataCol.MeaDayInjLiqDens.disabled = true;
      dataCol.MaxDayEstBhp.disabled = true;
      dataCol.AveDayEstBhp.disabled = true;
      dataCol.AveDayMeasBhp.disabled = false;
      dataCol.MaxDayMeasBhp.disabled = false;

      dataCol.ShutinTimeForStaticPress.required = true;
      dataCol.ShutinTimeForStaticPress.disabled = false;
    }
    else if (methodId == 3) {
      dataCol.ShutinBHPDaily.required = true;

      dataCol.ShutinBHPQuarterlyCalc.disabled = true;
      dataCol.ShutinBHPQuarterlyMeas.disabled = true;

      dataCol.MaxDayEstBhp.disabled = true;
      dataCol.AveDayEstBhp.disabled = true;
      dataCol.AveDayMeasBhp.disabled = false;
      dataCol.MaxDayMeasBhp.disabled = false;

      dataCol.ShutinTimeForStaticPress.required = false;
      dataCol.ShutinTimeForStaticPress.disabled = true;
    }

    return dataCol;
  }

  public GetEmptyDailySubmittableBatch(wellId: number, beginDate: Date, endDate: Date, useLastSubmission: boolean) {

    let lBeginDate = beginDate.getTime() / 1000;
    let lEndDate = endDate.getTime() / 1000;

    let tzo = beginDate.getTimezoneOffset();

    let tzoms = tzo * 60.0;

    let lBeginDateActuallyUtc = this.convertToActuallyUTC(beginDate, 12, 0, 0).getTime() / 1000;
    let lEndDateActuallyUtc = this.convertToActuallyUTC(endDate, 12, 0, 0).getTime() / 1000;

    let suls = "false";

    if (useLastSubmission == true) {
      suls = "true";
    }

    let url = "api/" + this._controllerName + "/Empty?wellId=" + wellId + "&begin=" + lBeginDateActuallyUtc + "&end=" + lEndDateActuallyUtc + "&useLastSubmission=" + suls;

    this.httpClient.get(url).pipe(catchError(this.handleSubmitBatchError)).subscribe(async (result: UserSubmittableDataBatch) => {

      let injBatch = <UserSubmittableDataBatch>result;
      let persistList = await this.GetPersistList();
      //add metadata values to persistList
      persistList = persistList.concat(['MeasurementDate', 'Id', 'WellId']);
      result.Injections = result.Injections.map(inj => {
        for (let key in inj) {
          //clear values that are not on the persist list.
          if (!persistList.includes(key)) {
            inj[key] = '';
          }
        }
        return inj;
      });

      this.currentBatch.next(injBatch);
    },
      (result) => {

      });
  }
}
